import { requestApiGet } from "../api/BacklogApiEndpoint";
import type { BacklogConfig } from "../contracts/BacklogConfig";
import type { BacklogApiContext } from "../contracts/api/BacklogApiContext";
import type { BacklogResponse } from "../contracts/api/BacklogResponse";
import type { Activity } from "../entities/Activity";
import { assert } from "../utils/BacklogUtil";
import type { GetActivityParams } from "./params/GetActivityParams";

/**
 * Get Recent Updates 最近の更新の取得
 *
 * Returns recent updates in your space.
 */
export function getActivity(
	config: BacklogConfig,
	params: GetActivityParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<Activity>> {
	assert(params);
	return requestApiGet({
		config,
		path: "activities/:activityId",
		params,
		context,
	});
}
